'use client';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { Button } from '@/app/components/_catalyst/button';
import { Text } from '@/app/components/_catalyst/text';
import { useTranslation } from '@/app/i18n/client';
import { fallbackLng, languages } from '@/app/i18n/settings';
import { errorTracker } from './services/errorTracking';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const pathname = usePathname();
  const segment = pathname.split('/')[1];
  const lng = languages.includes(segment ?? '') ? (segment ?? '') : fallbackLng;
  const { t } = useTranslation(lng, 'error');

  useEffect(() => {
    // Because `error` is guaranteed to be an `Error` instance,
    // you can pass it directly. No type checks needed.
    errorTracker.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="space-y-4">
          <Text className="text-cPrimary text-4xl font-bold tracking-tight sm:text-5xl dark:text-white">
            {t('title')}
          </Text>
          <Text className="text-base">{t('description')}</Text>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button onClick={() => reset()}>{t('tryAgain')}</Button>
          <Button href={`/${lng}/dashboard`} outline>
            {t('goToDashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
}
